import { useState } from "react";
import {
  ProductWarrantyStoreNameWidgetStyled,
  ModalBodyStyled,
} from "./styled";
import { portalService } from "apiServices";
import { toast } from "react-toastify";
import { Displays, Forms, Icons, Modals } from "components";

const ProductWarrantyStoreNameWidget = ({
  productWarrantyID,
  store_name_by_admin,
  store_name_note,
  store_name,
  onUpdateSuccess,
}) => {
  const [_isBgLoading, _setIsBgLoading] = useState(false);
  const [_renderModal, _setRenderModal] = useState(false);

  const _handleClickModal = () => {
    _setRenderModal(
      <Forms.ProductWarrantyStoreNameForm
        inititalValues={{
          store_name_by_admin,
          store_name_note,
          store_name
        }}
        onCloseModal={_handleCloseModal}
        onSubmit={_handleSubmit}
      />
    );
  };
  const _handleCloseModal = () => {
    _setRenderModal(false);
  };

  const _handleSubmit = async (values) => {
    _setIsBgLoading(true);
    let params = {
      store_name_by_admin: values.store_name_by_admin,
    };
    if (values.store_name_note) {
      params.store_name_note = values.store_name_note;
    }
    let res = await portalService.PUT_PRODUCT_WARRANTEE_UPDATE(
      productWarrantyID,
      params
    );
    if (res && res.status === 200) {
      onUpdateSuccess && onUpdateSuccess();
      toast.success("อัพเดทชื่อร้านสำเร็จ");
      _setIsBgLoading(false);
      _handleCloseModal();
    } else {
      _setIsBgLoading(false);
      toast.error("ไม่สามารถอัพเดทชื่อร้านได้ กรุณาลองใหม่อีกครั้ง");
    }
  };

  return (
    <>
      <ProductWarrantyStoreNameWidgetStyled onClick={_handleClickModal}>
        Detail
        <Icons.Edit />
      </ProductWarrantyStoreNameWidgetStyled>
      <Modals.BodyEmpty
        isShowModal={_renderModal ? true : false}
        onCloseModal={_handleCloseModal}
      >
        <ModalBodyStyled>
          <Displays.BGLoading visible={_isBgLoading} />
          <div className="btn_close_modal" onClick={_handleCloseModal}>
            <Icons.CloseX />
          </div>
          {_renderModal}
        </ModalBodyStyled>
      </Modals.BodyEmpty>
    </>
  );
};

export default ProductWarrantyStoreNameWidget;
